var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8489 34.9497L13.8489 34.9497L13.842 34.9444L13.842 34.9444L13.8416 34.9441L13.8413 34.9439L13.8364 34.9401L13.8131 34.922C13.7918 34.9054 13.7588 34.8794 13.715 34.8445C13.6274 34.7746 13.4966 34.6687 13.3286 34.5282C12.9927 34.2473 12.5088 33.8289 11.9264 33.2861C10.7603 32.1994 9.20536 30.6199 7.65216 28.6518C4.5294 24.695 1.5 19.278 1.5 13.2013C1.5 6.49744 7.08625 1 13.994 1C20.9029 1 26.5 6.49858 26.5 13.2013C26.5 19.278 23.4701 24.695 20.3467 28.6518C18.7932 30.6198 17.238 32.1994 16.0717 33.2861C15.4891 33.8289 15.0052 34.2472 14.6691 34.5282C14.5012 34.6686 14.3703 34.7746 14.2827 34.8445C14.2389 34.8794 14.2059 34.9053 14.1845 34.922L14.1613 34.94L14.1564 34.9438L14.156 34.944L14.1557 34.9443L14.1556 34.9444L14.1487 34.9497C14.0627 35.0168 13.9349 35.0168 13.8489 34.9497ZM21.1359 13.2013C21.1359 9.32646 17.8969 6.20304 13.994 6.20304C10.0891 6.20304 6.86169 9.32847 6.86168 13.2013C6.86165 17.0726 10.0876 20.2066 13.994 20.2066C17.8984 20.2066 21.136 17.0747 21.1359 13.2013Z",
    stroke: "#000064",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSvg);
export default __webpack_public_path__ + "static/media/mapSvg.5567b9150efb7385b3bfe10017f8e74e.svg";
export { ForwardRef as ReactComponent };